import React, { useEffect } from 'react';
import { X, CheckCircle, AlertCircle, Info } from 'lucide-react';

export type ToastType = 'success' | 'error' | 'info';

interface ToastProps {
  message: string;
  type: ToastType;
  onClose: () => void;
  duration?: number;
}

const Toast: React.FC<ToastProps> = ({ message, type, onClose, duration = 3000 }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const icons = {
    success: <CheckCircle size={20} color="#28a745" />,
    error: <AlertCircle size={20} color="#dc3545" />,
    info: <Info size={20} color="#2575fc" />,
  };

  const backgrounds = {
    success: 'rgba(40,167,69,0.1)',
    error: 'rgba(220,53,69,0.1)',
    info: 'rgba(37,117,252,0.1)',
  };

  return (
    <div style={{
      position: 'fixed',
      top: '20px',
      right: '20px',
      zIndex: 10000,
      animation: 'slideIn 0.3s ease-out',
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        background: 'rgba(255,255,255,0.95)',
        backdropFilter: 'blur(10px)',
        padding: '12px 20px',
        borderRadius: '12px',
        boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
        border: `1px solid ${type === 'success' ? '#28a745' : type === 'error' ? '#dc3545' : '#2575fc'}`,
        minWidth: '280px',
      }}>
        {icons[type]}
        <span style={{ flex: 1, fontSize: '14px', color: '#1a1a2e' }}>{message}</span>
        <button onClick={onClose} style={{
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          color: '#999',
          display: 'flex',
          alignItems: 'center',
        }}>
          <X size={16} />
        </button>
      </div>
      <style>{`
        @keyframes slideIn {
          from { transform: translateX(100%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
      `}</style>
    </div>
  );
};

export default Toast;